import { ref } from "vue";
import { getAuth } from "firebase/auth";
import services from "@/services";

export function useEmailVerification() {
  const errorMessage = ref("");


  const sendVerificationEmail = async (email) => {
    try {
      await services.auth.sendVerificationEmail(email);
    } catch (error) {
      console.log("[verification] Failed to send email:", error);
      errorMessage.value = "Failed to send verification email.";
    }
  };

  const sendRepresentativeDashboardEmail = async (email, name) => {
    try {
      const alreadySent = localStorage.getItem("rep-email-sent");
      if (alreadySent) return;

      await services.verification.sendRepresentativeDashboardEmail(email, name);
      localStorage.setItem("rep-email-sent", "true");
    } catch (error) {
      console.log("[verification] Error sending dashboard email:", error);
    }
  };

  const waitForEmailVerification = async (maxWait = 10000, interval = 1000) => {
    const auth = getAuth();
    const user = auth.currentUser;
    const start = Date.now();

    return new Promise((resolve) => {
      const check = async () => {
        await user.reload();
        if (user.emailVerified) {
          resolve(true);
        } else if (Date.now() - start >= maxWait) {
          resolve(false);
        } else {
          setTimeout(check, interval);
        }
      };
      check();
    });
  };

  return {
    errorMessage,
    sendVerificationEmail,
    sendRepresentativeDashboardEmail,
    waitForEmailVerification,
  };
}
